// extracted by mini-css-extract-plugin
export default {"categoryBanner":"ggtD7u8paZk5j41PntV4","card":"yURFtU0FaDoLi51KXImw"};